module.exports = __webpack_public_path__ + "static/sport/left-head.2d69d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/left-head.png
// module id = jhk+
// module chunks = 0